export default __webpack_public_path__ + "static/media/146feae4e0c09ef58939bc356554c385.svg";